import React, {
  ChangeEvent,
  SyntheticEvent,
  useState,
  ComponentType,
} from 'react';

import api from '../../services/api';
import { toaster } from '../../services/toaster';
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Alert from "@mui/material/Alert/Alert";
import TextField from "@mui/material/TextField";
import {LoadingButton} from "@mui/lab";

interface Props {
  /*onLogin: (session: Session) => void;*/
}

function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {'Copyright © '}
      <Link color="inherit" href="https://stagemporium.com/">
        stagemporium.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


export const ResetPasswordPage: ComponentType<Props> = () => {
  const [name, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event: SyntheticEvent): Promise<void> => {
    event.preventDefault();

    if (!name) {
      setError('Please enter your email');
    } else {
      setLoading(true);
      try {
        const sessionData = await api.post(
          `/reset-password`,
          { name: name, redirect_url: window.location.href },
          true
        );
        toaster.show({
          message: `Email send successfully`,
          intent: 'success',
        });
        //auth.setToken(sessionData.id);
      } catch (error) {
        console.error(error);
        setError('Invalid credentials');
      }
      setLoading(false);
    }
  };

  const defaultTheme = createTheme();

  return (

    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{
          background: '#fff',
          height: {
            xs: '100vh',
            md: 'auto',
          },
          borderRadius: {
            md: '15px',
          },
          boxShadow: {
            md: '0px 2px 15px -9px #0000006b',
          },
          mt: {
            md: '100px',
          },
          py: '50px',
        }}
      >
        <CssBaseline/>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar
            sx={{m: 1, bgcolor: 'secondary.main'}}
            src={
              'https://www.stagemporium.com/wp-content/themes/stagsemporium/images/logo.png'
            }
          >
            <LockOutlinedIcon/>
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>

          {error && (
            <Alert
              severity="error"
              sx={{
                width: '100%',
                mt: '10px',
              }}
            >
              {error}
            </Alert>
          )}

          <Box component="form" noValidate sx={{mt: 1}}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              name="name"
              onChange={({
                           target: {value},
                         }: ChangeEvent<HTMLInputElement>) => setUsername(value)}
            />
            <LoadingButton
              loading={loading}
              fullWidth
              variant="contained"
              sx={{mt: 3, mb: 2}}
              onClick={(event) => {
                handleLogin(event);
              }}
            >
              Reset Password
            </LoadingButton>

          </Box>
        </Box>
        <Copyright sx={{mt: 6}}/>

      </Container>
    </ThemeProvider>


  );
};
